import { Trans, useTranslation } from 'react-i18next';

import useCancelScheduledMessageMutation from 'components/domain/automation/scheduledMessages/useCancelScheduledMessageMutation';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { BaseErrorResponse } from 'models/_base';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import { getErrorMessage } from 'utils/axiosExceptionUtils';

const useScheduledMessagesCancelModal = () => {
  const { openConfirmModal } = useAppModal();
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useNotify();

  const onError = (error: BaseErrorResponse) => {
    notifyError(
      getErrorMessage({
        apiErrorCode: error.response?.data?.apiErrorCode,
        apiErrorMessage: error.response?.data?.apiErrorMessage ?? '',
        baseKey: 'pageAutomations.triggers.apiErrorCodes.',
        t,
      }),
    );
  };

  const { mutateAsync: cancelScheduledMessage } =
    useCancelScheduledMessageMutation();

  const openCancelScheduledMessagesModal = ({
    scheduledMessage,
  }: {
    scheduledMessage: ScheduledMessage;
  }) => {
    openConfirmModal({
      body: (
        <Trans
          i18nKey="pageAutomations.scheduledMessages.modalCancel.body"
          components={{ br: <br /> }}
          values={{
            name: scheduledMessage.messageName,
            date: scheduledMessage.expectedFireTime ?? new Date(),
          }}
        />
      ),
      confirmLabel: t('pageAutomations.scheduledMessages.modalCancel.title'),
      confirmColor: 'danger',
      onConfirmAsync: async () => {
        await cancelScheduledMessage(
          {
            scheduledMessageUid: scheduledMessage.uid,
          },
          {
            onError,
            onSuccess: () => {
              notifySuccess(
                t('pageAutomations.scheduledMessages.modalCancel.success'),
              );
            },
          },
        );
      },
      title: t('pageAutomations.scheduledMessages.modalCancel.title'),
    });
  };

  return { openCancelScheduledMessagesModal };
};

export default useScheduledMessagesCancelModal;
